import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button as AntButton, Modal, Select } from 'antd';
import { IAuth } from '../../models/auth.model';
import { ICampusItem, ICampusGroup } from '../../models/campuses.model';
import { getCampusGroup } from '../../lib/util';
import { campusHeadOffice } from '../../lib/data';

interface IProps {
  auth: IAuth;
  campusData: ICampusItem[];
  addCampusVisible: boolean;
  setAddCampusVisible: (visible: boolean) => void;
  addCampus: () => void;
  campusToAdd: string|undefined;
  setCampusToAdd: (campusToAdd: string|undefined) => void;
}

const AddCampusModal: FC<IProps> = ({
  auth,
  campusData,
  addCampusVisible,
  setAddCampusVisible,
  addCampus,
  campusToAdd,
  setCampusToAdd,
}) => {
  const { t, i18n } = useTranslation();
  const [campusList, setCampusList] = useState<any>(null);

  useEffect(() => {
    if (auth && campusData) {
      const campusGroups = getCampusGroup(campusData, campusHeadOffice);
      if (auth.hqYn === 'N' && auth.campus.length > 1) {

        // 멀티캠퍼스 대응
        const _campusGroups = campusGroups.map((campusGroup: ICampusGroup)=> {
          return {
            ...campusGroup,
            campuses: campusGroup.campuses.filter((item: ICampusItem)=> auth.campus.includes(item.campusCode))
          }
        })
        setCampusList(_campusGroups)
        
      } else {
        setCampusList(campusGroups)
      }
      
    }
  }, [auth, campusData]);

  const onCancel = () => {
    setCampusToAdd(undefined);
    setAddCampusVisible(false);
  }

  return (
    <Modal
      title={t('campus.staff.button6')}
      visible={addCampusVisible}
      onCancel={onCancel}
      width={400}
      footer={[
        <div className='comm-btn__area justify-content-center'>
          <AntButton
            key="submit"
            className='btn-basic pink'
            onClick={addCampus}
          >
            {t('common.button.confirm')}
          </AntButton>
          <AntButton
            key="cancel"
            className='btn-basic gray'
            onClick={onCancel}
          >
            {t('common.button.cancel')}
          </AntButton>
        </div>
      ]}
    >
      <div className='comm-bx__space'>
        <div className='flex justify-content-center'>
          <span className='text-md'>{t('campus.staff.text5')}</span>
        </div>
      </div>
      <Select
        className="w-100"
        placeholder={t('campus.staff.placeholder2')}
        value={campusToAdd}
        onChange={value => setCampusToAdd(value)}
      >
        { campusList?.map((campusGroup: ICampusGroup)=> (
          <Select.OptGroup
            key={`campus-group-key-${campusGroup.isTestCampus}`}
            label={ 
              t( campusGroup.isTestCampus
                ? 'campus.group.text2'
                : 'campus.group.text1'
              ) 
            }
          >
            {campusGroup.campuses
              .filter((item)=> item.campusStatus === 'NM')
              .map((item: any) => (
                <Select.Option
                  key={item.campusCode}
                  value={item.campusCode}
                >
                  {i18n.language === 'ko' ? item.campusKorName : item.campusEngName}
                </Select.Option>
              ))}
          </Select.OptGroup>
        ))}
        {
          /* {campusList?.slice(1)?.filter((item: any) => item.status === 'NM').map((item: any) => (
            <Select.Option
              key={item.value}
              value={item.value}
            >
              {item.label}
            </Select.Option>
          ))} */
        }
      </Select>
    </Modal>
  );
}

export default AddCampusModal;
